<template>
  <div class="content Tabs">

    <b-tabs card v-model="tabIndex">
      
      <b-tab :title="lang.tab_Parts" :title-link-class="textColors" :title-item-class="textColors"
        :active="tabIndex == 0">
        <p v-show="isAggregated == 'true'">{{lang.infotext_1}}:</p>
        <p v-show="isAggregated == 'false'">{{lang.infotext_2}}:</p>
        <b-form-checkbox id="isAggregatedCheckbox" v-model="isAggregated" name="isAggregatedCheckbox"
          value="false" unchecked-value="true">
          {{lang.checkbox_Aggregated}}
        </b-form-checkbox>
        <BomPartsTableComponent v-if="tabIndex == 0" v-show="isAggregated == 'true'" :lang="lang.PartsTable" :tabIndex="tabIndex">
        </BomPartsTableComponent>
        <BomPartsAggregatedTableComponent v-if="tabIndex == 0" v-show="isAggregated == 'false'" :lang="lang.PartsTable" :tabIndex="tabIndex">
        </BomPartsAggregatedTableComponent>
        <br><br>
        
      </b-tab>
      <b-tab :title="lang.tab_PartsAlternative" :title-link-class="textColors" :title-item-class="textColors"
        :active="tabIndex == 1">
        <!-- <p>{{lang.infotext_3}}:</p> -->
        <p v-show="isAlternativeAggregated == 'true'">{{lang.infotext_3}}:</p>
        <p v-show="isAlternativeAggregated == 'false'">{{lang.infotext_4}}:</p>
        <b-form-checkbox id="isAlternativeAggregatedCheckbox" v-model="isAlternativeAggregated" name="isAlternativeAggregatedCheckbox"
          value="false" unchecked-value="true">
          {{lang.checkbox_Aggregated}}
        </b-form-checkbox>
        <BomPartsAlternativeTableComponent v-if="tabIndex == 1" v-show="isAlternativeAggregated == 'true'" :lang="lang.PartsAlternativeTable" :tabIndex="tabIndex">
        </BomPartsAlternativeTableComponent>
        <BomPartsAlternativeAggregatedTableComponent v-if="tabIndex == 1" v-show="isAlternativeAggregated == 'false'" :lang="lang.PartsAlternativeTable" :tabIndex="tabIndex">
        </BomPartsAlternativeAggregatedTableComponent>
        <br><br>
        
      </b-tab>
      <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_ExtendedBom" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 2">
        <!-- <p>{{lang.infotext_5}}:</p> -->
        <p v-show="isExtendedAggregated == 'true'">{{lang.infotext_5}}:</p>
        <p v-show="isExtendedAggregated == 'false'">{{lang.infotext_6}}:</p>
        <b-form-checkbox id="isExtendedAggregatedCheckbox" v-model="isExtendedAggregated" name="isExtendedAggregatedCheckbox"
          value="false" unchecked-value="true">
          {{lang.checkbox_Aggregated}}
        </b-form-checkbox>
        <BomExtendedTableComponent v-if="tabIndex == 2" v-show="isExtendedAggregated == 'true'" :lang="lang.ExtendedBom" :tabIndex="tabIndex"></BomExtendedTableComponent>
        <BomExtendedAggregatedTableComponent v-if="tabIndex == 2" v-show="isExtendedAggregated == 'false'" :lang="lang.ExtendedBom" :tabIndex="tabIndex"></BomExtendedAggregatedTableComponent>
      </b-tab>
      <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_UsedLibraries" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 3">
        <p>{{lang.infotext_7}}:</p>
        <UsedLibrariesInBomComponent v-if="tabIndex == 3" :lang="lang.UsedLibraries" :tabIndex="tabIndex"></UsedLibrariesInBomComponent>
      </b-tab>
      

    </b-tabs>

  </div>

</template>
<script>
import { mapGetters } from 'vuex'

import BomPartsTableComponent from '@/components/shared/BomPartsTableComponent'
import BomPartsAlternativeTableComponent from '@/components/shared/BomPartsAlternativeTableComponent'
import BomPartsAggregatedTableComponent from '@/components/shared/BomPartsAggregatedTableComponent'
import BomPartsAlternativeAggregatedTableComponent from '@/components/shared/BomPartsAlternativeAggregatedTableComponent'
import BomExtendedTableComponent from '@/components/shared/BomExtendedTableComponent'
import BomExtendedAggregatedTableComponent from '@/components/shared/BomExtendedAggregatedTableComponent'
import UsedLibrariesInBomComponent from '@/components/shared/UsedLibrariesInBomComponent'

export default {
  name: "Content",
  components: {
    BomPartsTableComponent,
    BomPartsAlternativeTableComponent,
    BomPartsAggregatedTableComponent,
    BomPartsAlternativeAggregatedTableComponent,
    BomExtendedTableComponent,
    BomExtendedAggregatedTableComponent,
    UsedLibrariesInBomComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {
      tabIndex: 0,
      isAggregated: "false",
      isAlternativeAggregated: "false",
      isExtendedAggregated: "false",
      isBom: false,
      
      file: null,
    }
  },
  computed: {
     ...mapGetters({

      appConf: 'appConf',
    }),
    tabIndex2() {
      return this.$store.getters.tabData
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    }

  },
  created () {
    this.getTabIndex();
    

  },
  
  watch: {
    tabIndex: function (newVal) {

      let obj = {};
      obj[this.$route.path + "__middle"] = newVal;

      this.$store.commit("SETTABDATA", obj);

      //####################

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow");
      this.$parent.$parent.$parent.switchButtons(newVal);
    },
  },
  methods: {
    getTabIndex() {
      

      if (this.$store.getters.tabData[this.$route.path + "__middle"] != undefined) {
        this.tabIndex = this.$store.getters.tabData[this.$route.path + "__middle"];
      } else {
        this.tabIndex = 0;
      }

    },
  }
}
</script>

<style scooped>

  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectBom/Middle/Content/Content.vue